import React from "react";
import Styled from "styled-components";
function ExpAndEdu() {
  const edu = [
    {
      degree: "10th",
      name: "Vidya Niketan School",
      duration: "2017",
    },
    {
      degree: "12th",
      name: "Vidya Niketan School",
      duration: "2019",
    },
    {
      degree: "B.Tech",
      name: "GLA University",
      duration: "2019 - 2023",
    },
  ];
  const exp = [
    {
      position: "Associate Application Engineer",
      CompanyName: "Hexaview Technologies",
      duration: "June 2022-Present",
      desc:[]
    },
    {
      position: "Intern",
      CompanyName: "Era Interfaces",
      duration: "May2021-Aug 2021",
      desc: ["Face mask Recognition using AWS Rekognition","Python module:- Boto3"]
    }
  ];
  return (
    <div style={{paddingBottom:"10vh"}}>
      <Heading>Experience & Education</Heading>
      <DetailsCont>
        <Exp>
          {exp.map((data, i) => {
            let { position, CompanyName, duration, desc } = data;
            return (
              <LiCont>
                <SideBar>
                  <Colapse>
                    <i className="fas fa-briefcase"></i>
                  </Colapse>
                  <hr
                    style={{
                      borderTop: "none",
                      borderRight: "none",
                      borderLeft: "1px solid #323232",
                      borderBottom:"none",
                      height: "15vh",
                      width: 0,
                      margin: 0,
                      padding: 0,
                    }}
                  />
                </SideBar>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                  }}
                >
                  <Duration>{duration}</Duration>
                  <DesigCont>
                    <div>
                      <span
                        style={{
                          fontSize: "18px",
                          fontFamily: "sans-serif",
                          fontWeight: 600,
                        }}
                      >
                        {position} -{" "}
                      </span>
                      <span style={{ fontSize: "15px" }}>{CompanyName}</span>
                    </div>
                  </DesigCont>
                  <Desc>{desc.map((data,i)=>{
                    return(
                      <li style={{listStyle:"disc"}}>{data}</li>
                    )
                  })}</Desc>
                </div>
              </LiCont>
            );
          })}
        </Exp>
        <Edu>
          {edu.map((data, i) => {
            let { degree, name, duration } = data;
            return (
              <LiCont>
                <SideBar>
                  <Colapse>
                    <i className="fas fa-briefcase"></i>
                  </Colapse>
                  <hr
                    style={{
                      borderTop: "none",
                      borderRight: "none",
                      borderLeft: "1px solid #323232",
                      borderBottom:"none",
                      height: "15vh",
                      width: 0,
                      margin: 0,
                      padding: 0,
                    }}
                  />
                </SideBar>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "1rem",
                    justifyContent:"center"
                  }}
                >
                  <Duration>{duration}</Duration>
                  <DesigCont>
                    <div>
                      <span
                        style={{
                          fontSize: "18px",
                          fontFamily: "sans-serif",
                          fontWeight: 600,
                        }}
                      >
                        {degree} -{" "}
                      </span>
                      <span style={{ fontSize: "15px" }}>{name}</span>
                    </div>
                  </DesigCont>
                </div>
              </LiCont>
            );
          })}
        </Edu>
      </DetailsCont>
    </div>
  );
}
const Heading = Styled.span`
    color:white;
    font-size:30px;
    font-family:poppins;
    font-weight:550;
    letter-spacing:1px;
    display:block;
    text-align:center;
    margin-bottom:3rem;
    text-transform:capitalize;
    @media (max-width:425px){
      font-size:25px;
    }
`;

const DetailsCont = Styled.ul`
    display:flex;
    flex-diretion:column;
    color:white;
    margin:0;
    padding:0;
    @media (max-width:768px){
      flex-wrap:wrap;
      flex-direction:column;
      justify-content:center;
    }
`;
const LiCont = Styled.li`
    list-style:none;
    display:flex;
    margin:20px 0;
    
`;
const Duration = Styled.span`
    background:#32323290;
    padding:4px 8px 4px 8px;
    border-radius:50px;
    width:fit-content;
    margin-top:10px;
`;
const DesigCont = Styled.div`
    display:flex;
    text-transform:uppercase;
`;
const Desc = Styled.ul`

`;
const SideBar = Styled.div`
  display:flex;
  justify-content:center;
  flex-direction:column;
  align-items:center;
  margin-right:10px;
`;
const Colapse = Styled.span`
  border-radius:50%;
  height:40px;
  width:40px;
  z-index:1;
  justify-content:center;
  align-items:center;
  display:flex;
  position:relative;
  color:white;
  background:#ffb400;
  border:2px solid #ffb400;
  margin:0 10px;
  pointer-events:none;
  cursor:pointer;
`;
const Exp = Styled.div`
display:flex;
  flex-wrap:wrap;
  flex-direction:column;
  color:white;
  width:50%;
  margin:0;
  padding:0;
  @media (max-width:768px){
    width:100%;
    order:1;
  }
`;
const Edu = Styled.div`
  display:flex;
  flex-wrap:wrap;
  flex-direction:column;
  color:white;
  margin:0;
  width:50%;
  @media (max-width:768px){
    order:2;
    width:100%;
  }
`;
export default ExpAndEdu;
